export function isDateString(value) {
  // matchar exakt YYYY-MM-DD
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}
